import React from 'react'
import PropTypes from 'prop-types'
import LevelSelect from '../AccessSelect/AccessSelect'
import EmailMultiInput from '../../common/EmailMultiInput/EmailMultiInputContainer'
import { StyledButton as Button } from '../../common/Button'
import { withTranslation } from 'react-i18next'
import styled from 'react-emotion'

import { StyledFormElement as FormElement } from '../../common/FormElement'
import { space } from '../../../style'
import { Icon } from 'common/components/Icon'
import Text from 'common/components/Text'

export const InviteInput = styled(
  ({
    className,
    values,
    focus,
    blur,
    focused,
    setFieldValue,
    setFieldTouched
  }) => (
    <FormElement className={className} large highlight={focused}>
      <EmailMultiInput
        value={values.users}
        setValue={value => {
          setFieldValue('users', value)
          setFieldTouched('users')
        }}
        focus={focus}
        blur={blur}
      />
      <LevelSelect onFocus={focus} onBlur={blur} />
    </FormElement>
  )
)({
  label: 'InviteInput',
  height: 'auto',
  marginRight: space.default,
  flex: 1,
  select: {
    alignSelf: 'flex-start',
    marginTop: 10
  }
})

const InviteForm = styled(props => {
  const {
    show,
    showing,
    values,
    isValid,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    submitForm,
    focus,
    focused,
    blur,
    className,
    t
  } = props
  return showing ? (
    <div className={className}>
      <InviteInput
        {...{ values, focus, blur, focused, setFieldValue, setFieldTouched }}
      />
      <Button
        large
        onClick={submitForm}
        inactive={!isValid || isSubmitting}
        primary={isValid}
      >
        {t('share.invite')}
      </Button>
    </div>
  ) : (
    <div className={className} onClick={show}>
      <Button rounded>
        <Icon icon="plus" />
      </Button>
      <FormElement borderless>
        <Text medium>{t('share.addMember')}</Text>
      </FormElement>
    </div>
  )
})({
  border: '1px solid #E6E6E6',
  alignItems: 'flex-start',
  padding: space.default,
  display: 'flex',
  flex: 1
})

InviteForm.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  isValid: PropTypes.bool,
  submitForm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
}

export default withTranslation()(InviteForm)
